import { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/447348371266";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Mobile", href: "#mobile" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 border-b ${
        scrolled
          ? "bg-brand-charcoal/90 backdrop-blur-xl border-brand-line"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-baseline gap-2 group">
          <span className="font-display italic font-extrabold uppercase text-lg md:text-xl tracking-tight text-white leading-none">
            Castleford
          </span>
          <span className="font-display italic font-bold uppercase text-lg md:text-xl tracking-tight text-brand-red leading-none group-hover:text-brand-redhover transition-colors duration-200">
            ECU
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(" ", "-")}`}
              className="relative text-sm uppercase tracking-widest text-brand-grey hover:text-white transition-colors duration-200 after:absolute after:left-0 after:-bottom-1.5 after:h-px after:w-0 after:bg-brand-red hover:after:w-full after:transition-[width] after:duration-300"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-message-btn"
          className="hidden md:inline-flex items-center gap-2 bg-brand-red hover:bg-brand-redhover text-white text-sm font-semibold uppercase tracking-wider px-5 py-2.5 rounded-sm transition-colors duration-200"
        >
          <MessageCircle size={16} strokeWidth={2.4} />
          Message Us
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-white p-2 -mr-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-brand-charcoal/97 backdrop-blur-xl border-t border-brand-line px-5 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-base uppercase tracking-widest text-brand-offwhite hover:text-brand-red transition-colors"
            >
              {n.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            data-testid="mobile-message-btn"
            className="mt-2 inline-flex items-center justify-center gap-2 bg-brand-red text-white font-semibold uppercase tracking-wider px-5 py-3 rounded-sm"
          >
            <MessageCircle size={16} /> Message Us
          </a>
        </div>
      )}
    </header>
  );
};
